import AttributeName from './AttributeName'

export default AttributeName
